import { API } from 'aws-amplify';
import { API_NAME, getConfig, handleError, validateResponse } from './apiUtils';

export function createRewardItem(market, category, brand, body) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/reward`;
    return getConfig(body)
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getRewardItem(market, category, brand, rewardId) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/reward/${rewardId}`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getRewardItemList(market, category, brand) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/reward`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function updateRewardItem(market, category, brand, rewardId, body) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/reward/${rewardId}`;

    return getConfig(body)
        .then((config) => API.put(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function deleteRewardItem(market, category, brand, rewardId) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/reward/${rewardId}`;

    return getConfig()
        .then((config) => API.del(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
